import { Modal } from '@mantine/core';
import useCreateTag from '../../../hooks/tags/useCreateTag.ts';
import MutateTagForm, {
  MutateTagFormValues,
} from '../../ui/tags/MutateTagForm.tsx';
import { CreateTagRequest } from '../../../api/requests/tag-request.ts';
import { notifyError } from '../../../utils/NotifyError.tsx';
import { useMutation } from '@tanstack/react-query';
import { ErrorResponse } from '../../../api/responses/error-response.ts';

interface AddTagModalProps {
  opened: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const AddTagModal = ({ opened, onClose, onSuccess }: AddTagModalProps) => {
  const { mutateAsync: createTag } = useCreateTag();

  const { mutate: handleSubmit, isPending: isCreateTagPending } = useMutation<
    void,
    ErrorResponse,
    MutateTagFormValues
  >({
    mutationFn: async (formValues) => {
      const createTagRequest: CreateTagRequest = {
        name: formValues.name,
        description: formValues.description,
      };

      await createTag(createTagRequest);
    },
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      if (error.code === 'TAG_NAME_ALREADY_EXISTS') {
        return notifyError('新增標籤失敗', '標籤名稱已存在');
      } else {
        notifyError('新增標籤失敗', error.message);
      }
    },
  });

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="新增標籤"
      centered
      closeOnClickOutside={false}
      styles={{ title: { fontWeight: 700, fontSize: 16 } }}
    >
      <MutateTagForm
        initialValues={{
          name: '',
          description: '',
        }}
        onSubmit={handleSubmit}
        onCancel={onClose}
        isSubmitting={isCreateTagPending}
        isUpdating={false}
        submitButtonText={'新增'}
      />
    </Modal>
  );
};

export { AddTagModal };
